// Instrumentación del framework de rollout (§5 del plan). Una sola función aplica las
// dimensiones `menu_version` + `menu_state` a los 3 sinks de observabilidad para que
// los 107 eventos existentes se vuelvan comparables treatment/control:
//   - GA4: user_properties (viajan en cada evento siguiente).
//   - Clarity: tags de sesión (filtrar replays).
//   - Sentry: tags globales (delta de errores).
//
// Es síncrona y tolerante: si un sink está apagado (tracking off / no-prod), no rompe.

import { ga4SetUserProperties } from '@utils/analytics/ga4';
import { claritySetTags } from '@utils/analytics/clarity';
import { setFeatureVersionTags } from '@utils/print/printSentry';
import type { FeatureMenuState, FeatureVariant } from './types';

export interface FeatureVersionTags {
  menu_version: FeatureVariant;
  menu_state: FeatureMenuState | null;
}

export function applyFeatureVersionTags(tags: FeatureVersionTags): void {
  const flat = {
    menu_version: tags.menu_version,
    menu_state: tags.menu_state ?? undefined,
  };
  ga4SetUserProperties(flat);
  claritySetTags(flat);
  setFeatureVersionTags({ menu_version: tags.menu_version, menu_state: tags.menu_state });
}
